import { DBConnectionType, DBConnectorConfig } from 'ihub/common';
import { AdvancedTourStep } from '../shared-types';
import { TaskTourProps } from './task-tour-props';

export function getDatabaseConnectorTourSteps({
	defaultStyles,
	microTaskConfigType,
}: Readonly<TaskTourProps>): AdvancedTourStep[] {
	if (!microTaskConfigType) return [];
	const config = microTaskConfigType as DBConnectorConfig;
	return [
		{
			id: 'connector-type',
			selector: '[data-tour="connector-type"]',
			content: 'Required: The type of database being connected to.',
		},
		{
			id: 'test-connection',
			selector: '[data-tour="test-connection"]',
			content:
				'The button will attempt to connect to the database using the provided configuration in order to verify if the details work..',
		},
		{
			id: 'host',
			selector: '[data-tour="host"]',
			content:
				'Required: This is the host name of the system hosting the database. The name can be provided as an IP or DNS name.',
		},
		{
			id: 'port',
			selector: '[data-tour="port"]',
			content: 'Required:The port number the database provider uses to connect.',
		},
		{
			id: 'username',
			selector: '[data-tour="username"]',
			content: 'Required: The database username that should be used to login and run the query.',
		},
		{
			id: 'password',
			selector: '[data-tour="password"]',
			content: 'Required: The database password that should be used to login and run the query.',
		},
		{
			id: 'db-name',
			selector: '[data-tour="db-name"]',
			content: 'Required: The specific database the query should be run on.',
		},
		...(config.type === DBConnectionType.MSSQL
			? [
					{
						id: 'timeout',
						selector: '[data-tour="timeout"]',
						content:
							'Required: The duration the query is allowed to run before it automatically times out.',
					},
					{
						id: 'encrypt',
						selector: '[data-tour="encrypt"]',
						content:
							'The security of the data, enabling will encrypt the data returned by the query.',
					},
					{
						id: 'certificate',
						selector: '[data-tour="certificate"]',
						content: 'Whether the Server certificate should be a Trusted certificate or not.',
					},
				]
			: []),

		{
			id: 'query',
			selector: '[data-tour="query"]',
			content:
				'Required: The plain SQL query that will be run on the database.** Note that this query is currently plain free text and has no SQL validation added. It is also currently open to SQL injection.',
		},
	].map(tourItem => ({ ...tourItem, styles: defaultStyles }));
}
